
import ncNanoId from "utils/ncNanoId";
//
//
export const NAVIGATION_MOBILE_MENU = [

  {
    id: ncNanoId(),
    href: "/new-implements",
    name: "Buy New",
    // type:'dropdown',
    // children: [
    //   { id: ncNanoId(), href: "/new-implements", name: "Buy Old" },
    //   { id: ncNanoId(), href: "/new-implements", name: "Buy New" },
    // ],
  },
  {
    id: ncNanoId(),
    href: "/buy-used",
    name: "Buy Used",

  },

  {
    id: ncNanoId(),
    href: "",
    name: "Rentals",
  },
  {
    id: ncNanoId(),
    href: "",
    name: "Service",
  },

  {
    id: ncNanoId(),
    href: "",
    name: "Parts",
  },

  {
    id: ncNanoId(),
    href: "/reviews",
    name: "Reviews",
  },

  {
    id: ncNanoId(),
    href: '/sell-used',
    name: "Sell Used",
  },

  {
    id: ncNanoId(),
    href: '/posts',
    name: "Blog",
  },
  {
    id: ncNanoId(),
    href: "/resources",
    name: "Resources",
    type: "dropdown",
    children: [
      { id: ncNanoId(), href: "", name: "Advertise with Us" },
      { id: ncNanoId(), href: "", name: "Prime Membership" },
      { id: ncNanoId(), href: "", name: "Guest Post" },
    ],

  },
  {
    id: ncNanoId(),
    href: "/locations",
    name: "Location",
    type: "dropdown",
    children: [
      { id: ncNanoId(), href: "", name: "Delhi" },
      { id: ncNanoId(), href: "", name: "Rajasthan" },
      { id: ncNanoId(), href: "", name: "Haryana" },
    ],

  },

];
